export default (props) => {
  return <h2 className="Heading">{props.children}</h2>;
}
